import React from "react";

import { TeaserLayoutWrapper } from "../../../components/teaser-components/TeaserLayoutWrapper/TeaserLayoutWrapper";
import { MediaTextTeaserElement } from "./MediaTextTeaserElement/MediaTextTeaserElement";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./ContentTeaserMediaText.module.less";

export function ContentTeaserMediaText({
    data: {
        anker,
        tagline,
        headline,
        semanticOfHeadline,
        teaser = [],
        semanticOfTeaserHeadline,
        background,
        display,
        mediaAlignLeft
    },
    hasLightBackground
}) {
    const teaserElements = teaser.filter((teaser) => !!teaser);
    return (
        <TeaserLayoutWrapper
            anker={anker}
            tagline={tagline}
            headline={headline}
            semanticOfHeadline={semanticOfHeadline}
            containerClass={gcs(styles.mediaTextTeaserContainer)}
            background={background}
            hasLightBackground={hasLightBackground}
        >
            <div
                className={gcs(
                    [display === "one_column", styles.teaserOne],
                    [display === "two_column", styles.teaserTwo]
                )}
            >
                {teaserElements.map((teaserElement) => {
                    if (teaserElement.type === "DatoCmsTeaser") {
                        teaserElement.teaserLink =
                            teaserElement.contentTeaserLink;
                        teaserElement.teaserText =
                            teaserElement.contentTeaserText;
                    }

                    const {
                        id,
                        teaserTagline,
                        teaserHeadline,
                        teaserImage,
                        division,
                        teaserText,
                        teaserDocument,
                        teaserLink,
                        teaserUrl
                    } = teaserElement;

                    return (
                        <MediaTextTeaserElement
                            key={id}
                            horizontalLayout={display === "one_column"}
                            mediaAlignLeft={mediaAlignLeft}
                            hasLightBackground={hasLightBackground}
                            teaserData={{
                                tagline: teaserTagline,
                                headline: teaserHeadline,
                                semanticOfHeadline: semanticOfTeaserHeadline,
                                image: teaserImage,
                                division,
                                text: teaserText,
                                document: teaserDocument,
                                link: teaserLink,
                                url: teaserUrl
                            }}
                        />
                    );
                })}
            </div>
        </TeaserLayoutWrapper>
    );
}
